module.exports = __webpack_public_path__ + "media/assets_v3/images/sign-box-banner-c0ff9ad7f245173bbeeef027001605ee.png";